if (!customElements.get('grid-swiper-slider')) {
  customElements.define('grid-swiper-slider',
    class gridSwiperSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null; // Initialize swiper as null
        // Function to initialize swiper
        const initSwiper = () => {
          this.swiper = new Swiper(this.querySelector('.swiper'), {
            slidesPerView: 1,
            scrollbar: {
              el: '.swiper-scrollbar',
            },
          });
        };

        const isMobile = () => {
          const match = window.matchMedia || window.msMatchMedia;
          if(match) {
            var mq = match("(pointer:coarse)");
            return mq.matches;
          }
          return false;
      }

        // Function to destroy swiper
        const destroySwiper = () => {
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        };

        // Function to handle window resize event
        const handleResize = () => {
          if (isMobile()) {
            initSwiper();
          } else {
            destroySwiper();
          }
        };

        // Initialize swiper on component creation
        if (isMobile()) {
          initSwiper();
        }

        const events = ['load', 'resize'];
        events.forEach(event => window.addEventListener(event, handleResize));
      }
    }
  );
}
